import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ReviewModerationPage from './ReviewModerationPage';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Review Moderation | Admin',
    component: (
      <AdminLayout>
        <ReviewModerationPage />
      </AdminLayout>
    ),
  };
}

export default action;
